<div class="modal-header">
  <h4 class="modal-title">
    {{ "campaignDetails.updateAdvertisingCampaign" | translate }} {{ ad.title }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col">
        <div class="mb-3">
          <label class="form-label label" for="exampleFormControlText">
            {{ "campaignDetails.campaignName" | translate }} *
          </label>
          <input
            class="form-control"
            id="exampleFormControlText"
            type="text"
            [placeholder]="'campaignDetails.campaignName' | translate"
            formControlName="title"
          />
        </div>
      </div>
    </div>
    <div
      *ngIf="
        userRole === roleEnum.ROLE_ADMIN &&
        ad.publisherRole === roleEnum.ROLE_FRANCHISE
      "
    >
      <div class="form-group mb-3">
        <label class="label"
          >{{
            "advertisingCampaign.create.options.franchise.franchise" | translate
          }}
          *</label
        >
        <input
          class="form-control"
          id="exampleFormControlText"
          type="text"
          formControlName="franchise"
          readonly
        />
      </div>
    </div>
    <div class="col mb-3" *ngIf="!isLPUser">
      <div class="form-group">
        <label class="label"
          >{{ "campaignDetails.locations" | translate }} *</label
        >
        <ng-select
          formControlName="locations"
          [items]="locations"
          [multiple]="ad.publisherRole === roleEnum.ROLE_FRANCHISE"
          [closeOnSelect]="false"
          [placeholder]="
            'advertisingCampaign.create.placeholders.selectLocations'
              | translate
          "
          [ngClass]="{
            'is-invalid':
              !form.get('locations')?.valid && form.get('locations')?.touched
          }"
          [required]="true"
        >
          <ng-template ng-header-tmp *ngIf="ad.publisherRole === roleEnum.ROLE_FRANCHISE">
            <div class="form-check checkbox checkbox-primary mb-0">
              <input
                class="form-check-input"
                id="checkbox-select-all"
                type="checkbox"
                [checked]="isAllSelected()"
                (click)="selectAllLocations($event)"
              />
              <label class="form-check-label label" for="checkbox-select-all">
                {{ "select.selectAllLocations" | translate }}
              </label>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div class="form-check checkbox checkbox-primary mb-0 ml-10">
              <input
                class="form-check-input m-r-10"
                type="checkbox"
                [checked]="form.get('locations')?.value?.includes(item)"
              />
              <label class="form-check-label label">{{ item }}</label>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="col">
      <label class="label">{{ "addCampaign.video" | translate }} *</label>
      <div class="m-b-10" *ngIf="showProgress">
        <ngb-progressbar [value]="uploadProgress"
          >{{ uploadProgress }}%</ngb-progressbar
        >
      </div>
      <ngx-dropzone
        [multiple]="false"
        (change)="onSelect($event.addedFiles)"
        accept="video/*"
      >
        <ngx-dropzone-label>
          <div>
            <div class="dz-message needsclick">
              <i class="icon-cloud-up"></i>
              <p style="color: black">{{ "dropzoneFile.title" | translate }}</p>
              <p class="dz-message needsclick" style="color: black">
                {{ "dropzoneFile.rulePart1" | translate }}
                <strong [ngClass]="{ 'txt-danger': showError }"
                  >{{ "dropzoneFile.rulePart2" | translate }} 5MB</strong
                >
              </p>
            </div>
          </div>
        </ngx-dropzone-label>
        <ngx-dropzone-preview
          *ngFor="let f of files"
          [file]="f"
          [removable]="true"
          (removed)="onRemove()"
        >
          <ngx-dropzone-label style="align-self: flex-end; margin: 0">
            <div class="ligne-top"></div>
            <div class="new-dropdown-label">
              {{ f.name.split(".")[0] | castFileName }} .{{
                f.type.split("/")[1]
              }}
            </div>
          </ngx-dropzone-label>
        </ngx-dropzone-preview>
      </ngx-dropzone>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    data-bs-dismiss="modal"
    (click)="close()"
  >
    {{ "buttons.close" | translate }}
  </button>
  <button
    class="btn btn-primary"
    (click)="update()"
    [disabled]="!form.valid || filename == null"
  >
    <loading-button
      [loading]="loading"
      [value]="'buttons.submit'"
      [icon]="null"
    ></loading-button>
  </button>
</div>
